import { NgModule, Optional, SkipSelf, ModuleWithProviders } from '@angular/core';

import { SettingsService } from './settings/settings.service';
import { TeamsChatService } from './teams-chat/teams-chat.service';
@NgModule({
  imports: [
  ],
  providers: [
    TeamsChatService,
  ],
  declarations: [
  ],
  exports: [
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        SettingsService,
        TeamsChatService,
      ]
    };
  }
}
